import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { delay, getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const qmsFrameworkChangeActions = {
  // Provide divisionId as separate param since QFC.divisionId is nullable
  add: (newQfcData, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_QMSFC.ADD });
    const apiEndpoint = `${BASE_URL}/api/qms/QmsFrameworkChange/${divisionId}`;
    try {
      const res = await axios.post(apiEndpoint, newQfcData);
      dispatch({
        type: QMS.CMT_QMSFC.ADD_FULFILLED,
        divisionId,
        qmsFrameworkChanges: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_QMSFC.ADD_REJECTED });
      logError(e);
    }
  },
  // Provide divisionId as separate param since QFC.divisionId is nullable
  update: (qfcData, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_QMSFC.UPDATE });
    const apiEndpoint = `${BASE_URL}/api/qms/QmsFrameworkChange/${divisionId}`;
    try {
      const res = await axios.put(apiEndpoint, qfcData);
      dispatch({
        type: QMS.CMT_QMSFC.UPDATE_FULFILLED,
        divisionId,
        qmsFrameworkChanges: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_QMSFC.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (qfcId, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_QMSFC.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsFrameworkChange/" + qfcId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({
        type: QMS.CMT_QMSFC.REMOVE_FULFILLED,
        divisionId,
        qmsFrameworkChanges: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_QMSFC.REMOVE_REJECTED });
      logError(e);
    }
  },
  removeRange: (qfcIds, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_QMSFC.REMOVE });
    const apiEndpoint_delete = `${BASE_URL}/api/qms/QmsFrameworkChange`;
    try {
      const delRes = await axios.delete(apiEndpoint_delete, {
        params: { ids: qfcIds || [] },
        paramsSerializer: (params) => qs.stringify(params),
      });
      if (delRes.data.message) {
        dispatch({ type: QMS.CMT_QMSFC.REMOVE_REJECTED });
        // Show alert
        alert(delRes.data.message);
      } else {
        const apiEndpoint_getAll =
          BASE_URL + "/api/qms/QmsFrameworkChange/List/" + divisionId;
        const res = await axios.get(apiEndpoint_getAll);
        dispatch({
          type: QMS.CMT_QMSFC.REMOVE_FULFILLED,
          divisionId,
          qmsFrameworkChanges: res.data,
        });
      }
    } catch (e) {
      dispatch({ type: QMS.CMT_QMSFC.REMOVE_REJECTED });
      logError(e);
    }
  },
  getAll: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_QMSFC.FETCH_ALL });
    const apiEndpoint = `${BASE_URL}/api/qms/QmsFrameworkChange/List/${divisionId}`;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.CMT_QMSFC.FETCH_ALL_FULFILLED,
        divisionId,
        qmsFrameworkChanges: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_QMSFC.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
};

export default qmsFrameworkChangeActions;
